import * as React from 'react';
import classnames from 'classnames';
import { AnimatePresence } from 'motion/react';
import { toast } from '@grandvisionhq/common';
import { CheckboxWithLabel } from '@grandvisionhq/forms';
import { useDispatch, useIntl, useSelector } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { toggleDeliveryAddress } from '../../../actions.js';
import 'lodash/isEmpty';
import '@grandvisionhq/utils';
import '../../../../mappers/errors-mapping.js';
import '../../../../utils/get-customer-details-payload.js';
import { isDelivery, isDeliveryExpress } from '../../../../utils/shipping-method.js';
import 'history';
import '../../../../models/cart/cart-state.js';
import '../../../../models/checkout/checkout-step-error-type.js';
import '../../../../models/checkout-settings.js';
import '../../../../models/step-shipping/shipping-methods.js';
import '../../../../models/shared.js';
import '../../../../utils/has-cart-errors.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import 'throttle-debounce';
import '@grandvisionhq/carts-v2';
import '../../../../slots/forms/form-context.js';
import '../../../../slots/summaries/summary-context.js';
import '../../../../slots/summaries/types.js';
import '../../../../state.js';
import { isBillingAndShippingAddressSame, getSelectedShippingMethod, getBillingAddress, getDeliveryAddress } from '../../../selectors.js';
import { BillingForm } from '../../Forms/BillingForm.js';
import { DeliveryForm } from '../../Forms/DeliveryForm.js';

const BillingAndDeliveryForm = ({ className  })=>{
    var ref2;
    const checkoutSettings = useCheckoutSettings();
    const dispatch = useDispatch();
    const { getLabel  } = useIntl();
    const isBillingAndDeliverySame = useSelector(isBillingAndShippingAddressSame);
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const billingAddressDetails = useSelector(getBillingAddress);
    const deliveryAddressDetails = useSelector(getDeliveryAddress);
    const isDelivery$1 = isDelivery(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method);
    const isDeliveryExpress$1 = isDeliveryExpress(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method);
    const labels = React.useMemo(()=>({
            differentDeliveryAddress: getLabel('checkout.shipment.differentDeliveryAddress'),
            deliveryAddress: getLabel('checkout.deliveryAddress')
        })
    , [
        getLabel
    ]);
    const isDeliveryAddressRequired = React.useMemo(()=>{
        var ref, ref1;
        return isDelivery$1 && Boolean((ref = checkoutSettings.shipping) === null || ref === void 0 ? void 0 : ref.requiredShippingCountry) && Boolean(billingAddressDetails === null || billingAddressDetails === void 0 ? void 0 : billingAddressDetails.country) && ((ref1 = checkoutSettings.shipping) === null || ref1 === void 0 ? void 0 : ref1.requiredShippingCountry) !== (billingAddressDetails === null || billingAddressDetails === void 0 ? void 0 : billingAddressDetails.country);
    }, [
        billingAddressDetails === null || billingAddressDetails === void 0 ? void 0 : billingAddressDetails.country,
        (ref2 = checkoutSettings.shipping) === null || ref2 === void 0 ? void 0 : ref2.requiredShippingCountry,
        isDelivery$1
    ]);
    const onToggleDeliveryAddress = React.useCallback(({ checked  })=>{
        if (isDeliveryAddressRequired) {
            toast.failed('checkout.address.requiredShippingCountry.errorMessage');
        } else {
            dispatch(toggleDeliveryAddress({
                enabled: !checked
            }));
        }
    }, [
        dispatch,
        isDeliveryAddressRequired
    ]);
    React.useEffect(()=>{
        if (isDeliveryAddressRequired) {
            // If delivery address is required, we enable it by default
            dispatch(toggleDeliveryAddress({
                enabled: true
            }));
        }
    }, [
        isDeliveryAddressRequired,
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement("section", {
        className: classnames('billing-and-delivery-form', className),
        "data-t": "billing-and-delivery-form"
    }, /*#__PURE__*/ React.createElement(BillingForm, null), (isDelivery$1 || isDeliveryExpress$1) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
        id: "usingDeliveryAddress",
        value: "usingDeliveryAddress",
        "data-t": "usingDeliveryAddress",
        checked: !Boolean(deliveryAddressDetails),
        onChange: onToggleDeliveryAddress,
        className: "billing-and-delivery-form__checkbox",
        label: labels.differentDeliveryAddress
    }), /*#__PURE__*/ React.createElement(AnimatePresence, null, deliveryAddressDetails && (isDeliveryAddressRequired || !isBillingAndDeliverySame) && /*#__PURE__*/ React.createElement(DeliveryForm, {
        deliveryAddressLabel: labels.deliveryAddress
    }))));
};

export { BillingAndDeliveryForm };
//# sourceMappingURL=BillingAndDeliveryForm.js.map
